import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiResult } from '../models/api-result';
import { ConfigAppOutputDto } from '@shared/api/model/config-app-output-dto';
import { environment } from 'environments/environment';
import { TimezoneAppOutputDto } from '@shared/api/model/timezone-app-output-dto';

@Injectable({
  providedIn: 'root'
})
export class AppService {

    static apiUrl = environment.gatewayApiUrl + "/api/di/v1"

    constructor(private http: HttpClient) {
    }

    getAppConfig(): Observable<ConfigAppOutputDto> {
        return this.http.get<ApiResult<ConfigAppOutputDto>>(`${AppService.apiUrl}/app/config`).pipe(
            map((result: ApiResult<ConfigAppOutputDto>) => (result.data as ConfigAppOutputDto)
        ));
    }

    getAppTimezones(): Observable<TimezoneAppOutputDto> {
        return this.http.get<ApiResult<TimezoneAppOutputDto>>(`${AppService.apiUrl}/app/timezones`).pipe(
            map((result: ApiResult<TimezoneAppOutputDto>) => (result.data as TimezoneAppOutputDto)
        ));
    }
}
